// extracted by mini-css-extract-plugin
module.exports = {"t2begpw":"t2begpw"};